"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: 0 0 70px 20px\n    rgba(", ", 0.2);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: 0 16px 16px 0\n    rgba(", ", 0.16);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: 0 4px 10px 0\n    rgba(", ", 0.22);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: 3px 2px 24px 0\n    rgba(", ", 0.09);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var shadowOne = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[700]);
});
var shadowTwo = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[700]);
});
var shadowThree = (0, _styledComponents.css)(_templateObject3(), function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[700]);
});
var shadowFour = (0, _styledComponents.css)(_templateObject4(), function (props) {
  return props.theme.utils.hexToRGB(props.theme.colors.blackberry[700]);
});
var _default = {
  shadowOne: shadowOne,
  shadowTwo: shadowTwo,
  shadowThree: shadowThree,
  shadowFour: shadowFour
};
exports["default"] = _default;